/* tslint:disable */

export class Object {

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Object.ts